import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useTutorialStore } from '../../stores/tutorialStore';

interface HelpButtonProps {
  pageName: string;  // Used to identify which tutorial to show
  className?: string;
}

export const HelpButton: React.FC<HelpButtonProps> = ({ pageName, className = '' }) => {
  const { setIsActive, setCurrentTutorial } = useTutorialStore();

  const handleClick = () => {
    setCurrentTutorial(pageName);
    setIsActive(true);
  };

  return (
    <button
      onClick={handleClick}
      className={`p-2 rounded-full hover:bg-white/10 transition-colors ${className}`}
      aria-label={`${pageName} Tutorial`}
    >
      <HelpCircle className="w-5 h-5 text-gold-400" />
    </button>
  );
};
